import React from 'react';
import {
  change,
  Field,
  FieldArray,
  getFormValues,
  isDirty,
  reduxForm,
  reset,
} from 'redux-form';
import { connect } from 'react-redux';
import { find, isEmpty } from 'lodash';
import LabelSection from 'components/sections/LabelSection';
import BankTypeField from 'components/Fields/ReduxForm/BankTypeField';
import {
  showModalDelete,
  showModalVerifyPhone,
  showModalVerifyOtp,
  onClickSendOtp,
  onClickSaveBankV2,
  onClickSaveUpdateBankV2,
  onClickOpenAssignOutletsModal,
  setBankAccountDetail,
  hideRightColumn,
} from 'actions/setting/bankAccount';
import FormField from './FormField';
import styles from './style.css';

class Form extends React.Component {
  render() {
    const {
      banks,
      errors,
      rightColumnType,
      handleSubmit,
      valid,
      isDirtyBankAccountForm,
    } = this.props;

    return (
      <form className={`${styles['form-wrapper']}`}>
        <div className={`${styles['field-wrapper']}`}>
          <div className="row">
            <div className={`${styles['form-label']}`}>
              <LabelSection title="bank account information" />
            </div>
            <div className="col-sm-12 form-group">
              <small>Bank Name</small>
              <div className={`${styles['field-bank-name']}`}>
                <Field
                  component={BankTypeField}
                  name="bankName"
                  banks={banks}
                  onChangeValue={e => this._onChangeBank(e, banks)}
                />
              </div>
              <Field component="hidden" name="bankId" />
            </div>
            <div className={`col-sm-12 form-group ${styles['form-field']}`}>
              <small>Account Number</small>
              <Field
                component={FormField}
                name="accountNumber"
                className="form-control"
                placeholder="Account Number"
                positiveNumberOnly
                maxFractionDigits={0}
                maxLength="25"
                customError={errors.accountNumber ? errors.accountNumber : ''}
              />
            </div>
            <div className={`col-sm-12 form-group ${styles['form-field']}`}>
              <small>Account Holder</small>
              <Field
                component={FormField}
                name="accountHolderName"
                className="form-control"
                placeholder="Full Name"
                maxLength="255"
                letterOnly
                showTextError="true"
                customError={
                  errors.accountHolderName ? errors.accountHolderName : ''
                }
              />
            </div>
            <div className={`${styles['form-label']}`}>
              <LabelSection title="assigned outlets" />
            </div>
            <div
              className={`col-sm-12 form-group ${
                styles['form-assigned-outlets']
              }`}
            >
              <FieldArray
                name="outlets"
                component={this._renderAssignedOutlets}
              />
            </div>
            <div className={`col-sm-12 form-group`}>
              <button
                className={`btn ${styles['btn-outline-primary']} ${
                  styles['btn-assign-outlet']
                }`}
                onClick={this._onClickAssignOutlet}
                disabled={this._isAssignOutletsDisabled()}
              >
                Assign Outlet
              </button>
            </div>
          </div>
        </div>
        <div className={`${styles['form-footer']}`}>
          {rightColumnType === 'edit' && (
            <div className={`${styles.tooltip}`}>
              <button
                className={`btn ${styles['btn-danger']}`}
                disabled={this._isDeleteDisabled()}
                onClick={this._onClickDelete}
              >
                <i className={`glyphicon glyphicon-trash`} />
              </button>
              {this._isDeleteDisabled() && (
                <span className={`${styles['tooltip-text']}`}>
                  You can only delete this bank account if no outlets are
                  assigned to it
                </span>
              )}
            </div>
          )}
          <span className="pull-right">
            <button
              className={`btn mr-10px ${styles['btn-outline-dark']} ${
                styles['btn-large']
              }`}
              type="button"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            <button
              className={`btn btn-primary ${styles['btn-large']}`}
              disabled={
                !valid || !this._isInputValid() || !isDirtyBankAccountForm
              }
              onClick={handleSubmit(this._onClickSaveBank)}
            >
              Save
            </button>
          </span>
        </div>
      </form>
    );
  }

  _renderAssignedOutlets = () => {
    const { bankAccountForm } = this.props;
    const outlets = bankAccountForm ? bankAccountForm.outlets : [];
    const newOutlets = bankAccountForm ? bankAccountForm.newOutlets : [];

    return (
      <div className="row">
        {outlets.length === 0 && newOutlets.length === 0 && (
          <div className={`col-sm-12 ${styles['row-outlets']}`}>
            <span className={`ml-20px ${styles['text-light-grey']}`}>
              No outlets assigned
            </span>
          </div>
        )}
        {newOutlets.map(newOutlet => {
          return (
            <div
              className={`col-sm-12 ${styles['row-outlets']} ${
                styles['bg-grey']
              }`}
              key={newOutlet.id}
            >
              <span>{newOutlet.name}</span>
              <span className={`pull-right ${styles.label}`}>New</span>
            </div>
          );
        })}
        {outlets.map(outlet => {
          return (
            <div
              className={`col-sm-12 ${styles['row-outlets']}`}
              key={outlet.id}
            >
              {outlet.name}
            </div>
          );
        })}
      </div>
    );
  };

  _onChangeBank = (e, banks) => {
    const bank = find(banks, bank => {
      return bank.name === e.target.value;
    });
    this.props.dispatch(change('bankAccountForm', 'bankName', e.target.value));
    this.props.dispatch(change('bankAccountForm', 'bankId', bank.id));
  };

  _onClickAssignOutlet = e => {
    const { bankAccountForm, outlets, bankAccounts, banks } = this.props;

    this.props.dispatch(
      onClickOpenAssignOutletsModal(
        bankAccountForm.bankAccId,
        outlets,
        bankAccounts,
        banks,
        bankAccountForm.newOutlets
      )
    );

    e.preventDefault();
    e.stopPropagation();
  };

  _onClickCancel = e => {
    this.props.dispatch(reset('bankAccountForm'));
    this.props.dispatch(setBankAccountDetail(null));
    this.props.dispatch(hideRightColumn());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickSaveBank = values => {
    const { bankAccountForm, otp, profile, rightColumnType } = this.props;

    if (!profile.is_phone_number_verified) {
      this.props.dispatch(showModalVerifyPhone());
      return;
    }

    const assignedOutlets = bankAccountForm.newOutlets.concat(
      bankAccountForm.outlets
    );

    if (assignedOutlets.length > 0) {
      if (otp.sent === undefined || !otp.sent) {
        this.props.dispatch(onClickSendOtp(profile.phone));
      }
      this.props.dispatch(showModalVerifyOtp());
      return;
    }

    if (rightColumnType === 'form') {
      this.props.dispatch(onClickSaveBankV2(values, profile));
    } else if (rightColumnType === 'edit') {
      this.props.dispatch(onClickSaveUpdateBankV2(values, profile));
    }
  };

  _onClickDelete = e => {
    this.props.dispatch(showModalDelete());
    e.preventDefault();
    e.stopPropagation();
  };

  _isInputValid = () => {
    const { errors } = this.props;
    return (
      isEmpty(errors.bankName) &&
      isEmpty(errors.accountNumber) &&
      isEmpty(errors.accountHolderName)
    );
  };

  _isDeleteDisabled = () => {
    const { bankAccountForm } = this.props;
    return bankAccountForm !== undefined && bankAccountForm.outlets.length > 0;
  };

  _isAssignOutletsDisabled = () => {
    const { bankAccountForm, outlets } = this.props;
    return (
      bankAccountForm !== undefined &&
      bankAccountForm.outlets.length === outlets.length
    );
  };
}

const validate = values => {
  const errors = {};
  if (values.accountNumber || values.bankName || values.accountHolderName) {
    if (!values.accountNumber) {
      errors.accountNumber = 'Account number is required';
    }
    if (!values.accountHolderName || values.accountHolderName.trim() === '') {
      errors.accountHolderName = 'Account holder is required';
    } else if (!/^[A-Za-z ]+$/.test(values.accountHolderName)) {
      errors.accountHolderName =
        'Account holder must contains letters and spaces only';
    }
    if (!values.bankName) {
      errors.bankName = 'Bank name is required';
    }
  } else {
    if (typeof values.bankName === 'undefined') {
      errors.bankName = 'Bank name is required';
    }
    if (typeof values.accountNumber === 'undefined') {
      errors.accountNumber = 'Account number is required';
    }
    if (typeof values.accountHolderName === 'undefined') {
      errors.accountHolderName = 'Account holder is required';
    }
  }
  return errors;
};

const mapForm = {
  form: 'bankAccountForm',
  touchOnBlur: false,
  touchOnChange: true,
  destroyOnUnmount: false,
  enableReinitialize: true,
  forceUnregisterOnUnmount: true,
  validate,
};

function mapStateToProps(state) {
  const {
    bankList,
    bankAccountDetail,
    bankAccountLists,
    errors,
    otp,
    outlets,
    profile,
    rightColumnType,
  } = state.setting.bankAccount;

  return {
    initialValues: {
      bankAccId: bankAccountDetail ? bankAccountDetail.bankAccId : undefined,
      bankId: bankAccountDetail ? bankAccountDetail.bankId : undefined,
      bankName: bankAccountDetail ? bankAccountDetail.bankName : undefined,
      accountNumber: bankAccountDetail
        ? bankAccountDetail.accountNumber
        : undefined,
      accountHolderName: bankAccountDetail
        ? bankAccountDetail.accountHolderName
        : undefined,
      outlets: bankAccountDetail ? bankAccountDetail.outlets : [],
      newOutlets: bankAccountDetail ? bankAccountDetail.newOutlets : [],
    },
    banks: bankList,
    bankAccounts: bankAccountLists,
    errors,
    outlets,
    otp,
    profile,
    rightColumnType,
    selectedBankAccount: bankAccountDetail,
    bankAccountForm: getFormValues('bankAccountForm')(state),
    isDirtyBankAccountForm: isDirty('bankAccountForm')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

let formBank = reduxForm(mapForm)(Form);
formBank = connect(
  mapStateToProps,
  mapDispatchToProps
)(formBank);

export default formBank;
